import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import FJAddAccountPanel from '@src/components/FJModals/FJShareModal/FJAddAccount/FJAddAccountPanel.tsx';
import FJPublishAction from '@src/redux/action/FJPublishAction.ts';
import { SHARE_BINDING_STATUS } from '@src/constants/FJShareSocialConstant.ts';

const FJAddAccountPanelContainer = () => {
    const dispatch = useAppDispatch();
    const activeData = useAppSelector(state => {
        return {
            youtube: state.share.youtube.linkAccountState !== SHARE_BINDING_STATUS.LINKED,
            linkedin: state.share.linkedin.linkAccountState !== SHARE_BINDING_STATUS.LINKED,
        };
    });
    const isShow = useAppSelector(state => state.share.isShowAddAccountPanel);

    const _onClose = () => {
        dispatch(FJPublishAction.hideAddAccountPanelAction());
    };

    const _onAddPlatform = (type: string) => {
        dispatch(FJPublishAction.addPublishPlatformAction(type));
    };

    if (isShow) {
        return <FJAddAccountPanel onClose={_onClose} activeData={activeData} onAddPlatform={_onAddPlatform} />;
    } else {
        return null;
    }
};

export default FJAddAccountPanelContainer;
